import { FC } from 'react';
import { useForm, Controller } from 'react-hook-form';
// Store
import { useAppSelector, useAppDispatch } from 'hooks/useStore';
// Async
import { recoverPassword } from 'store/user/userAsync';
// Selectors
import { selectLoading } from 'store/user/userSelectors';
// Layouts
import { Dialog, DialogTitle, DialogContent, DialogActions } from 'layouts/Dialog';
// Components
import { Input } from 'components/Controls';
import { Button } from 'components/Buttons';
// Utilities
import { isRequired, isEmail } from 'utilities/validation';
// i18next
import { useTranslation } from 'react-i18next';

interface IFormData {
  email: string;
}

type Props = {
  open: boolean;
  onClose: () => void;
};

const RecoverPasswordDialog:FC<Props> = ({
  // Props
  open, onClose
}) => {
  const { t } = useTranslation();
  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const loading:boolean = useAppSelector(selectLoading);

  const { control, handleSubmit, formState: { errors } } = useForm<IFormData>({
    defaultValues: {
      email: ''
    }
  });

  const onSubmit = handleSubmit(async (data:IFormData) => {
    try {
      await dispatch(recoverPassword(data)).unwrap();
      onClose();
    } catch(error){}
  });

  return (
    <Dialog size="sm" open={open} onClose={onClose}>
      <form onSubmit={onSubmit} noValidate>
        <DialogTitle title={t('dialogs.recoverPassword.title')} onClose={onClose} />
        <DialogContent>
          <Controller
            control={control} name="email" rules={{ required: isRequired, pattern: isEmail }}
            render={({ field: { value, onChange } }) => (
              <Input
                label={t('labels.email')} id="email" type="email" name="email" value={value}
                required={true}
                onChange={onChange}
                error={Boolean(errors.email)}
                errorText={errors.email ? errors.email.message : ''}
              />
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={onClose}
          >{t('buttons.cancel')}</Button>
          <Button
            className="ml-2"
            variant="contained"
            type="submit"
            loading={loading}
          >{t('dialogs.recoverPassword.recoverButton')}</Button>
        </DialogActions>
      </form>
    </Dialog>
  )
}

export default RecoverPasswordDialog;
